import {useProductSearchStore} from "../../model/store";
import GoodsCard from "../../../../entities/goods/ui/card/GoodsCard";
import React, {useRef} from "react";
import ProductListGrid from "../../../../shared/ui/productListGrid/ProductListGrid";
import CardSkeleton from "../../../../shared/ui/card/CardSkeleton";
import styled from "styled-components";
import GoodsSlider from "../../../../entities/goods/ui/slider/GoodsSlider";
import RecommendationTab from "../recommendation/RecommendationTab";
import ProductRowExpander from "../rowExpander/ProductRowExpander";
import {GoodsType} from "../../../../entities/goods/model/types/goods-type";

const StyledExpanded = styled.div`
    grid-column: 1 / -1; /* растягивается на всю строку */
    width: 100%;

    //& ~ .column-item {
    //    /* Стили для всех карточек после .recommendation-section */
    //    filter: blur(1px);
    //
    //}
`

/**
 * Компонент отображения списка товаров с поддержкой режима разворачивания строк.
 *
 * Использует данные из хранилища `useProductSearchStore`, включая:
 * - список продуктов
 * - статус загрузки
 * - данные пагинации
 *
 * Ключевая логика:
 * - Если нет результатов по фильтрам, но есть возвращённые товары — показывает заголовок "Альтернативные предложения"
 * - Если продукты загружены — отображает `ProductRowExpander` с возможностью раскрытия строки
 * - Для каждой карточки используется `GoodsCard` со слотами для превью (`GoodsSlider`) и кнопки корзины (`ToggleCartButton`)
 * - Если включён режим расширенной строки — отображается `RecommendationTab`
 * - В случае загрузки отображаются `CardSkeleton` вместо карточек
 *
 * @param {React.FC} - ToggleToCartButtonSlot
 * @returns JSX.Element — сетка с карточками товаров или плейсхолдерами
 */

interface ProductListProps {
    ToggleToCartButtonSlot: React.FC<{ goods: GoodsType }>;
}

export const ProductList: React.FC<ProductListProps> = ({
                                                            ToggleToCartButtonSlot
                                                        }) => {

    const products = useProductSearchStore(state => state.products);
    const metaPagination = useProductSearchStore(state => state.metaPagination);
    const isLoading = useProductSearchStore(state => state.isLoading);
    const containerRef = useRef<HTMLDivElement | null>(null);

    return (
        <ProductListGrid ref={containerRef}>
            {!!(metaPagination.count === 0 && Array.isArray(products) && products?.length) && (
                <h3 style={{gridColumn: '1 / -1'}}>Альтернативные предложения</h3>)}
            {Array.isArray(products)
                ?
                <ProductRowExpander products={products}
                                    containerRef={containerRef}
                                    renderColumn={(goods) => {
                                        return (
                                            <GoodsCard goods={goods}
                                                       isSkeleton={isLoading}
                                                       slotPreview={
                                                           <GoodsSlider images={[
                                                               "https://admin2.ifurn.pro/admin/uploads/goods_webp/big/134/1346/13468_7618_big.webp",
                                                               "https://admin2.ifurn.pro/admin/uploads/goods_webp/small/134/1346/13464_25734_small.webp",
                                                               "https://admin2.ifurn.pro/admin/uploads/goods_webp/small/134/1346/13465_7616_small.webp"
                                                           ]}/>
                                                       }
                                                       slotBasket={<ToggleToCartButtonSlot goods={goods}/>}
                                            />);
                                    }}
                                    renderRow={(isViewRow) => {
                                        return (isViewRow ?
                                                <StyledExpanded>
                                                    <RecommendationTab ToggleToCartButtonSlot={ToggleToCartButtonSlot}/>
                                                </StyledExpanded>
                                                : null
                                        )
                                    }
                                    }

                />

                : (isLoading) ? new Array(10).fill(1).map((_) => <CardSkeleton/>) : null
            }
        </ProductListGrid>
    )
}


